{
  "codexEntityForm": {
    "character": "Personage",
    "place": "Plaats",
    "faction": "Factie",
    "object": "Voorwerp",
    "concept": "Concept",
    "editName": "{{name}} bewerken",
    "newCodexEntry": "Nieuwe codexvermelding",
    "theWorldHasChangedTheDraft": "De wereld is gewijzigd. Het concept blijft bewaard; laad de vermelding opnieuw voordat je opslaat.",
    "portraitChooseAnImage": "Portret: kies een afbeelding",
    "change": "Wijzigen",
    "addPortrait": "Portret toevoegen",
    "portraitImage": "Portretafbeelding",
    "entryName": "Naam van de vermelding",
    "name": "Naam",
    "entryType": "Type vermelding",
    "customCategory": "Eigen categorie",
    "categoryEGDeityShipSpell": "Categorie, bijv. Godheid, Schip, Spreuk",
    "aliases": "Aliassen",
    "entryAliases": "Aliassen van de vermelding",
    "otherNamesOneAtATime": "Andere namen, een voor een…",
    "tags": "Labels",
    "entryTags": "Labels van de vermelding",
    "themesRolesArcs": "Thema’s, rollen, ontwikkelingen…",
    "collection": "Collectie",
    "entryCollection": "Collectie van de vermelding",
    "noCustomCollection": "Geen eigen collectie",
    "folder": "Map",
    "entryFolder": "Map van de vermelding",
    "unfiled": "Niet ingedeeld",
    "notes": "Notities",
    "entryNotes": "Notities bij de vermelding",
    "whoTheyAreWhatTheyWant": "Wie ze zijn, wat ze willen, wat de lezer nooit te vroeg mag weten…",
    "entryFields": "Velden van de vermelding",
    "fields": "Velden",
    "fieldTemplate": "Veldsjabloon",
    "template": "Sjabloon…",
    "schemaOf": "Schema van",
    "addMissingFields": "Ontbrekende velden toevoegen",
    "addField": "Veld toevoegen",
    "noCustomFieldYetFieldsGive": "Nog geen eigen veld. Velden geven een vermelding gestructureerde feiten — leeftijd, loyaliteit, een geheim — waar Controles over kunnen redeneren.",
    "sharedFieldNamesTypesAndOptions": "Gedeelde veldnamen, typen en opties beheer je in de collectie-instellingen. De waarden horen bij deze pagina.",
    "fieldNameN": "Veldnaam {{n}}",
    "fieldName": "Veldnaam",
    "fieldTypeN": "Veldtype {{n}}",
    "unknown": "Onbekend",
    "fieldValueN": "Veldwaarde {{n}}",
    "select": "Kies…",
    "yes": "Ja",
    "no": "Nee",
    "value": "Waarde",
    "chooseAnEntry": "Kies een vermelding…",
    "eGSpringOfYear12": "bijv. de lente van jaar 12, of de dag van het beleg",
    "below": "Hieronder",
    "unknownValueN": "Onbekende waarde {{n}}",
    "required": "Verplicht",
    "sharedField": "Gedeeld veld",
    "remove": "Verwijderen",
    "confirmRemoval": "Verwijdering bevestigen",
    "paragraph": "Alinea",
    "aFewLines": "Een paar regels…",
    "discardTheDraft": "Het concept verwerpen?",
    "confirmReload": "Herladen bevestigen",
    "keepEditing": "Verder bewerken",
    "reloadEntry": "Vermelding herladen",
    "cancel": "Annuleren",
    "chooseAnImageFileForThe": "Kies een afbeeldingsbestand voor het portret.",
    "thePortraitMustBeUnder8": "Het portret moet kleiner zijn dan 8 MiB.",
    "saveEntry": "Vermelding opslaan",
    "searchEntries": "Vermeldingen zoeken…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nieuwe codexvermelding",
    "savedToWorldCodexTheManuscript": "Opgeslagen in Wereld › Codex; het manuscript noemt haar waar je aan het typen was.",
    "createAndMention": "Aanmaken en noemen"
  },
  "continuityPanel": {
    "relationsOverTime": "Relaties in de tijd",
    "checkingRelations": "Relaties controleren…",
    "cancel": "Annuleren",
    "theProjectHasChangedRunThe": "Het manuscript of de wereld is gewijzigd sinds deze run. Voer de controles opnieuw uit om de relaties te vernieuwen.",
    "anAnalysisLimitWasReachedThe": "Er is een analyselimiet bereikt. Het resultaat is gedeeltelijk.",
    "ruleApplied": "Regel: “{{label}}”, {{rule}}.",
    "oneSourcePerTarget": "één bron voor elk doel",
    "oneTargetPerSource": "één doel voor elke bron",
    "interval": "van {{start}} tot {{end}}",
    "openScene": "{{scene}} openen",
    "findingReferenceMissing": "Verwijst naar een vermelding die niet meer bestaat.",
    "findingConfirmedWithoutEvidence": "Bevestigd zonder citaat uit de tekst, dus de bron kan niet worden gecontroleerd.",
    "findingEvidenceMissing": "Een citaat waarop dit steunt, is weg.",
    "findingEvidenceNotCurrent": "Een citaat waarop dit steunt, is niet bevestigd of komt niet meer overeen met de tekst.",
    "findingExclusiveNotEvaluable": "Kan niet aan de regel worden getoetst: er zijn een richting, beide uiteinden en een volledig tijdsbereik nodig.",
    "findingExclusiveOverlap": "Twee hiervan gelden tegelijk, wat de regel niet toestaat.",
    "findingOther": "Er valt iets te controleren in deze relatie.",
    "theProjectExceedsTheLimitOf": "Het project overschrijdt de limiet van deze analyse. Er zijn geen gegevens gewijzigd.",
    "theAnalysisExceededItsExecutionLimit": "De analyse heeft haar uitvoeringslimiet overschreden. Er zijn geen gegevens gewijzigd.",
    "analysisCancelled": "Analyse geannuleerd.",
    "checksNotCompletedTheTextAnd": "Controles niet voltooid. De tekst en de canon zijn niet gewijzigd."
  },
  "eventTimelinePanel": {
    "eventHistory": "Gebeurtenisgeschiedenis",
    "timeline": "Tijdlijn",
    "newEvent": "Nieuwe gebeurtenis",
    "searchEvents": "Gebeurtenissen zoeken",
    "searchEvents2": "Gebeurtenissen zoeken…",
    "timelineOrder": "Volgorde van de tijdlijn",
    "storyTime": "Verhaaltijd",
    "readingOrder": "Leesvolgorde",
    "dateStatus": "Datumstatus",
    "allDates": "Alle datums",
    "resolvedDates": "Bepaalde datums",
    "unresolvedDates": "Onbepaalde datums",
    "filterEventsByScene": "Gebeurtenissen filteren op scène",
    "allScenes": "Alle scènes",
    "scenes": "Scènes",
    "editEvent": "Gebeurtenis bewerken",
    "closeEventEditor": "Gebeurteniseditor sluiten",
    "theWorldHasChangedReloadThe": "De wereld is gewijzigd. Laad de gebeurtenis opnieuw voordat je opslaat; de conceptvelden blijven bewaard.",
    "eventTitle": "Titel van de gebeurtenis",
    "whatHappens": "Wat er gebeurt",
    "scene": "Scène",
    "eventScene": "Scène van de gebeurtenis",
    "notLinked": "Niet gekoppeld",
    "removedSceneSceneid": "Verwijderde scène — {{sceneId}}",
    "dateType": "Datumtype",
    "eventDateType": "Datumtype van de gebeurtenis",
    "unknown": "Onbekend",
    "definedInterval": "Vast tijdvak",
    "relativeToAnEvent": "Ten opzichte van een gebeurtenis",
    "start": "Begin",
    "eventStart": "Begin van de gebeurtenis",
    "endExclusive": "Einde (exclusief)",
    "eventEnd": "Einde van de gebeurtenis",
    "referenceEvent": "Referentiegebeurtenis",
    "select": "Kies…",
    "referenceToVerifyAnchoreventid": "Referentie om te controleren — {{anchorEventId}}",
    "events": "Gebeurtenissen",
    "offsetInTicks": "Verschuiving in ticks",
    "eventOffset": "Verschuiving van de gebeurtenis",
    "saveEvent": "Gebeurtenis opslaan",
    "closeReload": "Sluiten / herladen…",
    "discardTheDraftChanges": "De conceptwijzigingen verwerpen?",
    "discardDraft": "Concept verwerpen",
    "reloadEvent": "Gebeurtenis herladen",
    "keepEditing": "Verder bewerken",
    "noEventMatchesTheseFiltersEvents": "Geen gebeurtenis komt overeen met deze filters. Gebeurtenissen zijn waar de Controles over redeneren: wanneer iets gebeurde, en in welke scène de lezer het te weten komt.",
    "tickStart": "Tick {{start}}",
    "openScene": "Scène openen",
    "editTitle": "{{title}} bewerken",
    "removeTitle": "{{title}} verwijderen",
    "confirmEventRemoval": "Verwijdering van de gebeurtenis bevestigen",
    "cancel": "Annuleren",
    "theWorldHasChangedCancelAnd": "De wereld is gewijzigd: annuleer en open de bevestiging opnieuw.",
    "resolvedDate": "Bepaalde datum",
    "unknownDate": "Onbekende datum",
    "missingReference": "Ontbrekende verwijzing",
    "timeCycle": "Tijdcyclus",
    "dateOutOfRange": "Datum buiten bereik",
    "eventsFoundOfTotal_one": "{{count}} gebeurtenis gevonden · {{total}} in totaal",
    "eventsFoundOfTotal_other": "{{count}} gebeurtenissen gevonden · {{total}} in totaal",
    "removeThisEventReferences_one": "Deze gebeurtenis verwijderen? {{count}} directe verwijzing moet worden nagekeken.",
    "removeThisEventReferences_other": "Deze gebeurtenis verwijderen? {{count}} directe verwijzingen moeten worden nagekeken.",
    "showMoreEvents_one": "{{count}} gebeurtenis meer tonen",
    "showMoreEvents_other": "{{count}} gebeurtenissen meer tonen"
  },
  "fieldEditor": {
    "choose": "Kies…",
    "labelSearch": "{{label}} zoeken",
    "search": "Zoeken…",
    "labelOptions": "Opties voor {{label}}",
    "noMatch": "Geen resultaat.",
    "optionsOnePerLine": "Opties, één per regel",
    "fieldOptionsIndex": "Veldopties {{index}}",
    "addOptionIndex": "Optie {{index}} toevoegen",
    "newOption": "Nieuwe optie",
    "addOption": "Optie toevoegen",
    "fieldValueIndex": "Veldwaarde {{index}}",
    "chooseOptions": "Kies opties…",
    "chooseEntries": "Kies vermeldingen…",
    "unsupportedMultiValueEditor": "Niet-ondersteunde editor voor meerdere waarden"
  },
  "graphExplorer": {
    "relationGraph": "Relatiegrafiek",
    "entry": "Vermelding",
    "filterGraphByEntry": "Grafiek filteren op vermelding",
    "all": "Alle",
    "status": "Status",
    "graphRelationStatus": "Status van de relatie in de grafiek",
    "proposedAndConfirmed": "Voorgesteld en bevestigd",
    "confirmed": "Bevestigd",
    "proposed": "Voorgesteld",
    "relation": "Relatie",
    "searchRelationInTheGraph": "Relatie in de grafiek zoeken",
    "filterAtStoryTime": "Filteren op verhaaltijd",
    "tick": "Tick",
    "graphTick": "Tick in de grafiek",
    "includeUnknownTime": "Onbekende tijd meenemen",
    "enterANumericTickOrTurn": "Vul een numerieke tick in of zet het tijdfilter uit.",
    "navigableRelationGraph": "Navigeerbare relatiegrafiek",
    "selectName": "{{name}} selecteren",
    "entryCount_one": "{{count}} vermelding",
    "entryCount_other": "{{count}} vermeldingen",
    "relationCount_one": "{{count}} relatie",
    "relationCount_other": "{{count}} relaties",
    "hiddenBeyondViewLimit": "{{entries}} en {{relations}} buiten de weergavelimiet.",
    "relationsWithMissingEntries_one": "{{count}} relatie met ontbrekende vermeldingen.",
    "relationsWithMissingEntries_other": "{{count}} relaties met ontbrekende vermeldingen.",
    "unknownDurationIncluded_one": "{{count}} relatie met onbekende duur is in het filter opgenomen.",
    "unknownDurationIncluded_other": "{{count}} relaties met onbekende duur zijn in het filter opgenomen.",
    "unknownDurationExcluded_one": "{{count}} relatie met onbekende duur is uit het filter uitgesloten.",
    "unknownDurationExcluded_other": "{{count}} relaties met onbekende duur zijn uit het filter uitgesloten."
  },
  "relationshipPanel": {
    "select": "Kies…",
    "removedReference": "Verwijderde verwijzing:",
    "projectRelations": "Relaties van het project",
    "relationsOf": "Relaties van",
    "filterRelationsByEntry": "Relaties filteren op vermelding",
    "allEntries": "Alle vermeldingen",
    "searchEntries": "Vermeldingen zoeken…",
    "searchRelations": "Relaties zoeken",
    "relationOrEntry": "Relatie of vermelding",
    "newRelation": "Nieuwe relatie",
    "editRelation": "Relatie bewerken",
    "relationsLinkTwoEntries": "Relaties verbinden twee vermeldingen",
    "addTwoEntriesInTheCodex": "Voeg minstens twee vermeldingen toe aan de Codex en schrijf dan de woorden die ze verbinden, zoals “is de mentor van”.",
    "theWorldHasChangedTheFields": "De wereld is gewijzigd terwijl dit openstond. Je velden blijven bewaard; laad opnieuw om op te slaan op basis van de nieuwe gegevens.",
    "reload": "Herladen",
    "anEntry": "Een vermelding",
    "anotherEntry": "Een andere vermelding",
    "relationSource": "Bron van de relatie",
    "relationType": "Type relatie",
    "isTheMentorOf": "is de mentor van",
    "relationTarget": "Doel van de relatie",
    "direction": "Richting",
    "relationDirection": "Richting van de relatie",
    "oneWay": "Eenzijdig",
    "bothWays": "Wederzijds",
    "when": "Wanneer",
    "relationTime": "Tijd van de relatie",
    "notSet": "Niet ingesteld",
    "betweenTwoMoments": "Tussen twee momenten",
    "fromAnEvent": "Vanaf een gebeurtenis",
    "from": "Van",
    "to": "tot",
    "relationStart": "Begin van de relatie",
    "relationEnd": "Einde van de relatie",
    "momentsHint": "Momenten op de tijdlijn van de wereld; het einde telt niet mee.",
    "event": "Gebeurtenis",
    "relationEvent": "Gebeurtenis van de relatie",
    "offset": "Verschuiving",
    "relationOffset": "Verschuiving van de relatie",
    "offsetHint": "Momenten na de gebeurtenis; negatief voor ervoor.",
    "status": "Status",
    "relationStatus": "Status van de relatie",
    "proposed": "Voorgesteld",
    "confirmed": "Bevestigd",
    "rejected": "Afgewezen",
    "superseded": "Vervangen",
    "confirmedRelationsCountAsCanonIn": "Bevestigde relaties tellen mee als canon in Controles.",
    "notes": "Notities",
    "relationNotes": "Notities bij de relatie",
    "howTheStoryShowsItAnd": "Hoe het verhaal het laat zien, en wat dubbelzinnig blijft.",
    "quotes": "Citaten",
    "linkQuotes": "Citaten uit de tekst koppelen",
    "quotesLinked": "Citaten: {{count}}",
    "searchQuotations": "Citaten zoeken",
    "excerptOrNote": "Fragment of notitie",
    "removedQuotation": "Verwijderd citaat:",
    "noQuotationYetAnnotateAPassage": "Nog geen citaat. Annoteer een passage in het manuscript om haar hier aan te halen.",
    "upTo100QuotationsShownUse": "Maximaal 100 citaten getoond. Gebruik het zoekveld om de lijst te beperken.",
    "saveRelation": "Relatie opslaan",
    "cancel": "Annuleren",
    "aDeletedEntry": "een verwijderde vermelding",
    "aDeletedEvent": "een verwijderde gebeurtenis",
    "timeBetween": "Van {{start}} tot {{end}}",
    "timeAtEvent": "Bij {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Nog geen relatie.",
    "noRelationMatches": "Geen relatie komt overeen.",
    "edit": "Bewerken",
    "editCaption": "{{caption}} bewerken",
    "remove": "Verwijderen",
    "removeCaption": "{{caption}} verwijderen",
    "removeThisRelationTheChangeStays": "Deze relatie verwijderen? De wijziging blijft in de geschiedenis staan.",
    "confirmRemoval": "Verwijderen",
    "shownOfTotal": "100 van {{total}} relaties getoond. Beperk de zoekopdracht om de andere te zien.",
    "theWorldHasChangedReloadThe": "De wereld is gewijzigd. Laad de relatie opnieuw voordat je opslaat.",
    "theRelationWasChangedOrRemoved": "De relatie is gewijzigd of verwijderd. Laad de gegevens opnieuw.",
    "explicitlyConfirmTheRelationBeforeSaving": "Kies opnieuw Bevestigd om van deze relatie canon te maken.",
    "selectTwoEntriesThatExistIn": "Kies twee vermeldingen die in de Codex bestaan.",
    "fillInTheTimeValuesOr": "Vul de momenten in, of kies Niet ingesteld.",
    "enterAValidIntervalTheEnd": "Het einde moet na het begin komen.",
    "selectAnExistingEventAsThe": "Kies een gebeurtenis die nog bestaat.",
    "theSelectedQuotationIsNoLonger": "Een gekozen citaat bestaat niet meer.",
    "checkTheRelationTextAndThe": "Controleer de woorden van de relatie en de notities.",
    "theChangeWasNotSavedReload": "De wijziging is niet opgeslagen. Laad de gegevens opnieuw en probeer het nog eens."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Log in op het gekoppelde account en controleer je toegang tot het project. Je lokale wijzigingen blijven bewaard.",
    "syncTheManuscriptWithThisServer": "Synchroniseer het manuscript met deze server voordat je de Wereld koppelt.",
    "theWorldChangedAfterTheComparison": "De Wereld is gewijzigd na de vergelijking. Bekijk de huidige kopieën opnieuw.",
    "aConfirmationOrRestoredRecordNeeds": "Een bevestiging of hersteld record moet expliciet worden nagekeken voordat het kan synchroniseren.",
    "anAttachmentOrRemoteCopyFailed": "Een bijlage of externe kopie is niet geverifieerd. Je lokale Wereld blijft bewaard.",
    "theseChangesExceedASyncLimit": "Deze wijzigingen overschrijden een synchronisatielimiet of moeten samen worden toegepast. Je lokale Wereld en openstaande wijzigingen blijven bewaard.",
    "syncPausedYourLocalChangesAre": "Synchronisatie gepauzeerd. Je lokale wijzigingen blijven bewaard.",
    "newMapNeedsPlan": "Nieuwe kaarten horen bij Ink en Press. De kaart blijft op dit apparaat en de Wereld wacht: verwijder de nieuwe kaart, of kies een abonnement, om opnieuw te synchroniseren.",
    "worldSyncCouldNotFinishCheck": "De synchronisatie van de Wereld kon niet worden voltooid. Controleer de verbinding en probeer het opnieuw. Je lokale wijzigingen blijven bewaard."
  },
  "vaultFolders": {
    "folderName": "Map {{name}}",
    "editFolder": "Map bewerken",
    "newSubfolder": "Nieuwe submap",
    "moveContentsBeforeRemoving": "Verplaats de inhoud voordat je verwijdert",
    "removeFolder": "Map verwijderen",
    "folderActionsName": "Acties voor map {{name}}",
    "chooseThisFolderWhenEditingA": "Kies deze map wanneer je een pagina bewerkt.",
    "projectFolders": "Projectmappen",
    "folders": "Mappen",
    "newFolder": "Nieuwe map",
    "groupPagesFromAnyCollection": "Groepeer pagina’s uit elke collectie.",
    "foldersOrganizePagesWithoutChangingTheir": "Mappen ordenen pagina’s zonder hun collectie of inhoud te wijzigen.",
    "cancel": "Annuleren",
    "saveFolder": "Map opslaan",
    "name": "Naam",
    "folderName2": "Mapnaam",
    "inside": "Binnen",
    "parentFolder": "Bovenliggende map",
    "projectRoot": "Hoofdmap van het project",
    "removeEmptyFolder": "Lege map verwijderen?",
    "removeNameFromTheProject": "“{{name}}” uit het project verwijderen?"
  },
  "vaultTable": {
    "unavailableEntry": "Niet-beschikbare vermelding",
    "vaultTable": "Archieftabel",
    "pages": "Pagina’s",
    "searchVaultTable": "Archieftabel doorzoeken",
    "searchPages": "Pagina’s zoeken…",
    "tableCollection": "Collectie van de tabel",
    "allCollections": "Alle collecties",
    "noCustomCollection": "Geen eigen collectie",
    "tableFolder": "Map van de tabel",
    "allFolders": "Alle mappen",
    "unfiled": "Niet ingedeeld",
    "scrollableVaultTable": "Scrolbare archieftabel",
    "name": "Naam",
    "collection": "Collectie",
    "folder": "Map",
    "noPagesMatchTheseFilters": "Geen pagina’s komen overeen met deze filters.",
    "none": "Geen",
    "yes": "Ja",
    "no": "Nee",
    "pagesShown_one": "{{shown}} van {{count}} pagina",
    "pagesShown_other": "{{shown}} van {{count}} pagina’s"
  },
  "vaultTree": {
    "blue": "Blauw",
    "emerald": "Smaragd",
    "gold": "Goud",
    "violet": "Violet",
    "rose": "Roze",
    "amber": "Amber",
    "teal": "Blauwgroen",
    "slate": "Leisteen",
    "crimson": "Karmozijn",
    "bark": "Schors",
    "forest": "Bosgroen",
    "navy": "Marineblauw",
    "orchid": "Orchidee",
    "saffron": "Saffraan",
    "ink": "Inkt",
    "ember": "Gloed",
    "concept": "Concept",
    "character": "Personage",
    "place": "Plaats",
    "faction": "Factie",
    "object": "Voorwerp",
    "vault": "Archief",
    "newCollection": "Nieuwe collectie",
    "vaultView": "Archiefweergave",
    "pages": "Pagina’s",
    "table": "Tabel",
    "pagesMarkedUnassignedKeepTheirPrevious": "Pagina’s die als niet-toegewezen zijn gemarkeerd, behouden hun vorige velden. Bewerk een pagina om haar collectie te kiezen.",
    "filterPages": "Pagina’s filteren",
    "filterPages2": "Pagina’s filteren…",
    "worldVault": "Archief van de wereld",
    "removeCollectionName": "Collectie {{name}} verwijderen",
    "collectionSettingsForName": "Collectie-instellingen voor {{name}}",
    "iconAndColour": "Pictogram en kleur",
    "newPageInName": "Nieuwe pagina in {{name}}",
    "noPageYetAddTheFirst": "Nog geen pagina — voeg de eerste toe met +.",
    "nothingHereYet": "Hier staat nog niets.",
    "removeEmptyCollection": "Lege collectie verwijderen?",
    "removeNameAndItsSchema": "“{{name}}” en het bijbehorende schema verwijderen?",
    "removeCollection": "Collectie verwijderen",
    "text": "Tekst",
    "theSvgMustBeUnder16": "De SVG moet kleiner zijn dan 16 KiB.",
    "thisFileIsNotAUsable": "Dit bestand is geen bruikbare SVG (scripts en externe verwijzingen worden verwijderd; de root moet <svg> zijn).",
    "collectionName": "Collectie: {{name}}",
    "sharedFieldsApplyToEveryPage": "Gedeelde velden gelden voor elke pagina in deze collectie. Elke pagina kan ook eigen velden hebben.",
    "cancel": "Annuleren",
    "saving": "Opslaan…",
    "saveCollection": "Collectie opslaan",
    "createCollection": "Collectie maken",
    "identity": "Identiteit",
    "nameAndIconAsTheTree": "Naam en pictogram, zoals de boom en de pagina’s ze tonen.",
    "name": "Naam",
    "collectionName2": "Naam van de collectie",
    "magic": "Magie",
    "aCollectionWithThisNameAlready": "Er bestaat al een collectie met deze naam.",
    "icon": "Pictogram",
    "iconSource": "Bron van het pictogram",
    "lucide181": "Lucide (181)",
    "yourSvg": "Je eigen SVG",
    "collectionIcon": "Collectiepictogram",
    "searchLucideIcons": "Lucide-pictogrammen zoeken",
    "searchIconsCastleSwordMoon": "Pictogrammen zoeken — kasteel, zwaard, maan…",
    "loadingIcons": "Pictogrammen laden…",
    "lucideIcon": "Lucide-pictogram",
    "noIconMatches": "Geen pictogram komt overeen.",
    "chooseAnSvgFile": "Kies een SVG-bestand",
    "customSvgIcon": "Eigen SVG-pictogram",
    "upTo16KibScriptsLinks": "Maximaal 16 KiB. Scripts, links en externe verwijzingen worden verwijderd; gebruik currentColor in het bestand zodat de kleur van de collectie wordt toegepast.",
    "colour": "Kleur",
    "aPresetOneYouUsedRecently": "Een voorinstelling, een die je onlangs gebruikte, of je eigen kleur uit het kleurenwiel.",
    "collectionColour": "Kleur van de collectie",
    "recent": "Recent",
    "useHex": "{{hex}} gebruiken",
    "kindOfPage": "Soort pagina",
    "everyPageIsACodexEntry": "Elke pagina is een codexvermelding van één soort; de soort bepaalt hoe Controles, @-vermeldingen en de grafiek haar behandelen, en behoudt overal haar kleur.",
    "collectionBaseKind": "Basissoort van de collectie",
    "magicOrShipsConceptDeitiesOr": "Magie of Schepen → Concept · Godheden of Huizen → Personage of Factie · een collectie steden → Plaats.",
    "sharedFields": "Gedeelde velden",
    "thePropertiesOfTheCollectionValues": "De eigenschappen van de collectie — de waarden staan op elke pagina, en een pagina kan er nog eigen aan toevoegen.",
    "collectionTemplate": "Collectiesjabloon",
    "template": "Sjabloon…",
    "addField": "Veld toevoegen",
    "exampleMagicLevelNumberRarityChoice": "Voorbeeld: Magie → Niveau (getal) · Zeldzaamheid (keuze: gewoon, zeldzaam, legendarisch) · Verkregen (verhaaldatum) · Onderwezen door (vermeldingslink).",
    "collectionFieldNameValue": "Veldnaam van de collectie {{value}}",
    "fieldName": "Veldnaam",
    "collectionFieldTypeValue": "Veldtype van de collectie {{value}}",
    "collectionFieldOptionsValue": "Veldopties van de collectie {{value}}",
    "optionsOnePerLine": "Opties, één per regel",
    "required": "Verplicht",
    "requiredCollectionFieldValue": "Verplicht collectieveld {{value}}",
    "removeCollectionFieldValue": "Collectieveld {{value}} verwijderen",
    "yesNo": "Ja / Nee",
    "multipleChoice": "Meerkeuze",
    "storyDate": "Verhaaldatum",
    "entryLink": "Vermeldingslink",
    "multipleEntryLinks": "Meerdere vermeldingslinks",
    "fieldParagraph": "Alinea",
    "fieldNumber": "Getal",
    "fieldChoice": "Keuze"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Cloudversies van de wereld",
    "includesCodexPagesCollectionsFoldersFacts": "Omvat codexpagina’s, collecties, mappen, feiten, relaties en bijlagen. Publiceer of download een versie expliciet. Het manuscript gebruikt scènesynchronisatie.",
    "compareVersions": "Versies vergelijken",
    "recoverPreviousWorld": "Vorige wereld herstellen…",
    "deviceRevision": "Apparaatrevisie",
    "accountVersionRemoteversion": "Accountversie {{remoteVersion}}",
    "firstAccountVersion": "Eerste accountversie",
    "uploadDeviceVersion": "Apparaatversie uploaden…",
    "useAccountVersion": "Accountversie gebruiken…",
    "confirmTransfer": "Overdracht bevestigen",
    "replaceWorldOnThisDeviceWith": "De Wereld op dit apparaat vervangen door deze versie? Eerst wordt een kopie van de huidige Wereld en bijlagen bewaard. De manuscripttekst blijft ongewijzigd.",
    "saveThisCopyToYourAccount": "Deze kopie in je account opslaan? Eerdere accountversies blijven bewaard.",
    "restoreWorldFromBeforeTheLast": "De Wereld herstellen naar de stand van vóór de laatste overdracht? Latere wijzigingen verhinderen dit herstel.",
    "confirm": "Bevestigen",
    "cancel": "Annuleren",
    "transferring": "Overdragen…",
    "codexPages": "Codexpagina’s",
    "updateStoryideBeforePublishingChangesTo": "Werk Musael bij voordat je wijzigingen in dit Archief publiceert.",
    "theAccountVersionChangedCompareAgain": "De accountversie is gewijzigd. Vergelijk opnieuw voordat je toepast.",
    "worldChangedOnThisDeviceCompare": "De Wereld op dit apparaat is gewijzigd. Vergelijk opnieuw voordat je toepast.",
    "accountVersionStorageIsFullPrevious": "De opslag voor accountversies is vol. Eerdere kopieën blijven bewaard.",
    "anAttachmentFailedItsIntegrityCheck": "Een bijlage is niet door de integriteitscontrole gekomen. Er is geen lokale kopie vervangen.",
    "theAccountCopyFailedItsIntegrity": "De accountkopie is niet door de integriteitscontrole gekomen.",
    "noRecoveryCopyIsAvailableFor": "Voor deze overdracht is geen herstelkopie beschikbaar.",
    "anIdentifierIsAlreadyUsedIn": "Een identifier wordt al in een ander project gebruikt.",
    "openOrSyncTheManuscriptWith": "Open of synchroniseer eerst het manuscript met je account.",
    "yourAccountDoesNotHaveThe": "Je account heeft niet de vereiste machtiging.",
    "signInAgainThisSessionWas": "Log opnieuw in. Deze sessie is ingetrokken.",
    "transferCancelled": "Overdracht geannuleerd.",
    "transferFailedCheckYourConnectionAnd": "Overdracht mislukt. Controleer je verbinding en vergelijk opnieuw.",
    "couldNotReadTheRecoveryCopy": "De herstelkopie kon niet worden gelezen.",
    "mondoPrecedenteRipristinato": "Vorige wereld hersteld.",
    "accountVersionVersionSaved": "Accountversie {{version}} opgeslagen.",
    "versionVersionAppliedToWorldOn": "Versie {{version}} toegepast op de Wereld op dit apparaat.",
    "cancellationRequested": "Annulering aangevraagd.",
    "labelFacts": "Feiten",
    "labelEvents": "Gebeurtenissen",
    "labelKnowledge": "Kennis",
    "labelAnnotations": "Annotaties",
    "labelRelationships": "Relaties",
    "labelAttachments": "Bijlagen",
    "labelCollections": "Collecties",
    "labelFolders": "Mappen",
    "changedCount_one": "{{count}} gewijzigd",
    "changedCount_other": "{{count}} gewijzigd"
  },
  "worldMaps": {
    "character": "Personage",
    "place": "Plaats",
    "object": "Voorwerp",
    "faction": "Factie",
    "concept": "Concept",
    "pinOf": "Pin: {{name}}",
    "pinMissing": "Pin van een ontbrekende vermelding",
    "missingEntry": "Ontbrekende vermelding",
    "zoom": "Zoom",
    "zoomIn": "Inzoomen",
    "zoomOut": "Uitzoomen",
    "fitToView": "Aanpassen aan weergave",
    "newMap": "Nieuwe kaart",
    "newMapDescription": "Een afbeelding van een plaats, voor pins op de mensen, plaatsen en dingen die er zijn.",
    "cancel": "Annuleren",
    "saving": "Opslaan…",
    "createMap": "Kaart maken",
    "mapOf": "Kaart van",
    "aNewPlace": "Een nieuwe plaats",
    "placeName": "Naam van de plaats",
    "placeNamePlaceholder": "De Zoutkust",
    "picture": "Afbeelding",
    "choosePicture": "Kies een PNG, JPEG, WebP of GIF",
    "pictureHint": "Maximaal 16 MB. Het wordt een van de bijlagen van de vermelding.",
    "maps": "Kaarten",
    "mapsLead": "Pin vermeldingen op de afbeeldingen van je plaatsen. Een vastgepinde plaats met een eigen kaart opent die kaart.",
    "noMapsYet": "Nog geen kaarten",
    "noMapsText": "Geef een plaats een afbeelding en pin dan de vermeldingen die daar thuishoren.",
    "addTheFirstMap": "De eerste kaart toevoegen",
    "onePin": "1 pin",
    "pins": "{{count}} pins",
    "inPlace": "op {{place}}",
    "chooseAnEntryOrName": "Kies een vermelding of schrijf een naam voor de pin.",
    "mapTrail": "Kaarten boven deze",
    "doneAdding": "Klaar",
    "addPin": "Pin toevoegen",
    "labels": "Labels",
    "replacePicture": "Afbeelding vervangen",
    "removeMap": "Kaart verwijderen",
    "hintClick": "Klik op de kaart waar de pin moet komen.",
    "hintChoose": "Kies rechts waar de pin naar wijst.",
    "pictureMissing": "De afbeelding van deze kaart staat nog niet op dit apparaat.",
    "pinDetails": "Details van de pin",
    "newPin": "Nieuwe pin",
    "entry": "Vermelding",
    "chooseAnEntry": "Kies een vermelding",
    "noEntryLabelOnly": "Geen vermelding, alleen een label",
    "labelOnTheMap": "Label op de kaart",
    "labelDefault": "De naam van de vermelding",
    "labelRequired": "Nodig zonder vermelding",
    "placePin": "Pin plaatsen",
    "label": "Label",
    "openEntry": "Vermelding openen",
    "openItsMap": "De bijbehorende kaart openen",
    "position": "{{x}}% van links, {{y}}% van boven",
    "removePin": "Pin verwijderen",
    "noPinsYet": "Nog geen pins. Gebruik Pin toevoegen en klik dan op de kaart.",
    "shownOn": "Getoond op",
    "openEntryOf": "{{name}} openen",
    "removeMapTitle": "De kaart van {{name}} verwijderen?",
    "removeMapMessage": "De pins verdwijnen mee. De afbeelding blijft bij de bijlagen van de vermelding."
  },
  "worldPanel": {
    "checks": "Controles",
    "findAndFixConsistencyIssuesIn": "De feiten, gebeurtenissen en relaties van je wereld vergeleken met het manuscript. Zonder AI.",
    "running": "Bezig…",
    "runChecks": "Controles uitvoeren",
    "lastRunAt": "Laatst uitgevoerd om {{time}}",
    "oneAtATime": "Eén tegelijk",
    "exclusiveRelation": "Exclusieve relatie",
    "noRelationIsExclusive": "Geen enkele relatie is exclusief",
    "exclusivityType": "Type exclusiviteit",
    "oneSourcePerTarget": "Eén bron voor elk doel",
    "oneTargetPerSource": "Eén doel voor elke bron",
    "oneAtATimeHint": "Een relatie die maar voor één tegelijk kan gelden, zoals “bezit”: twee eigenaars van hetzelfde ding op dezelfde momenten worden een conflict.",
    "rulesNeedRelations": "Regels gebruiken je relaties. Voeg er een toe bij Verbindingen, zoals “bezit”, en maak haar hier exclusief.",
    "results": "Resultaten",
    "whatTheChecksLookFor": "Waar de controles op letten",
    "twoHoldersAtOnce": "Twee bezitters tegelijk",
    "eventsOutOfOrder": "Gebeurtenissen in de verkeerde volgorde",
    "quotedPastItsLimit": "Geciteerd na de limiet",
    "linksToDeletedEntries": "Koppelingen naar verwijderde vermeldingen",
    "notesThatLostTheirPlace": "Notities die hun plek kwijt zijn",
    "relationsOverTime": "Relaties in de tijd",
    "scopeOwnership": "Eén ding dat op dezelfde momenten door twee vermeldingen wordt vastgehouden, volgens bevestigde feiten.",
    "scopeFlashback": "Een gebeurtenis die wordt gelezen na een gebeurtenis die later in de wereld plaatsvindt: een flashback, of een verspreking.",
    "scopeReveal": "Een feit dat in een scène wordt geciteerd na de laatste scène die je ervoor toestond.",
    "scopeOrphans": "Notities en feiten die verwijzen naar een vermelding of Bibliotheekkaart die niet meer bestaat.",
    "scopeAnchors": "Een geciteerde passage waarvan de woorden in haar scène zijn verplaatst of gewijzigd.",
    "scopeRelations": "Relaties getoetst aan de regel hierboven en aan de citaten die ze aanhalen.",
    "filterResults": "Resultaten filteren",
    "all": "Alle",
    "conflicts": "Conflicten",
    "warnings": "Waarschuwingen",
    "needsData": "Gegevens nodig",
    "noIssuesFound": "Geen problemen gevonden",
    "theExecutedRulesFoundNoViolation": "Niets doorbreekt de feiten en regels die je hebt ingesteld. Controles weten alleen wat je hebt vastgelegd.",
    "notEnoughData": "Te weinig gegevens",
    "quotesInTheText": "Citaten in de tekst",
    "anchorInPlace": "Op zijn plek",
    "anchorMoved": "Verplaatst",
    "anchorGone": "Verdwenen",
    "reAnchor": "Opnieuw verankeren",
    "openScene": "Scène openen",
    "checkedAt": "Gecontroleerd om {{time}}.",
    "twoHold": "{{a}} en {{b}} hebben allebei “{{object}}” op hetzelfde moment.",
    "heldTwice": "{{a}} heeft “{{object}}” twee keer op dezelfde momenten.",
    "flashbackSentence": "“{{earlier}}” gebeurt in de wereld vóór “{{later}}” maar wordt erna gelezen: een flashback, tenzij je dat niet bedoelde.",
    "revealSentence": "“{{fact}}” wordt geciteerd in {{scene}}, na de laatste scène die je ervoor toestond.",
    "allowedUpToScene": "Toegestaan tot en met scène {{scene}}",
    "orphanFactSentence": "Een feit (“{{fact}}”) gaat over een vermelding die is verwijderd.",
    "orphanNoteSentence": "De notitie bij “{{excerpt}}” verwijst naar een verwijderde vermelding.",
    "orphanConceptSentence": "De notitie bij “{{excerpt}}” verwijst naar een Bibliotheekkaart die niet meer bestaat.",
    "movedSentence": "“{{excerpt}}” is verplaatst in {{scene}}: verankeer de notitie opnieuw zodat ze meebeweegt.",
    "eventWithoutTime": "“{{title}}” heeft geen tijd in de wereld, dus de volgorde kan niet worden gecontroleerd.",
    "factWithoutTime": "“{{fact}}” heeft geen tijdsbereik, dus de bezitter kan niet worden gecontroleerd.",
    "recordWithoutTime": "Een record heeft geen tijd, dus het kan niet worden gecontroleerd.",
    "aDeletedEntry": "een verwijderde vermelding",
    "aDeletedEvent": "een verwijderde gebeurtenis",
    "aScene": "een scène",
    "fromTo": "Van {{start}} tot {{end}}",
    "relativeToAnEvent": "Ten opzichte van een gebeurtenis",
    "timeNotSet": "Niet ingesteld",
    "facts": "Feiten",
    "factsLead": "Wat je over elke vermelding vaststelt. Controles lezen degene die je bevestigt en vergelijken ze met het manuscript.",
    "entries": "Vermeldingen",
    "addAnEntry": "Een vermelding toevoegen",
    "addTheFirstEntry": "De eerste vermelding toevoegen",
    "newEntityName": "Naam van de nieuwe entiteit",
    "entityType": "Type entiteit",
    "addEntity": "Entiteit toevoegen",
    "character": "Personage",
    "place": "Plaats",
    "object": "Voorwerp",
    "faction": "Factie",
    "other": "Overig",
    "deleteEntityReferencesBecomeOrphaned": "Entiteit verwijderen (verwijzingen worden wees)",
    "deleteEntityName": "Entiteit {{name}} verwijderen",
    "noFactYet": "Nog geen feit over {{name}}. Een nieuw feit begint als voorgesteld; bevestig het om het mee te laten tellen.",
    "proposed": "Voorgesteld",
    "confirmed": "Bevestigd",
    "rejected": "Afgewezen",
    "superseded": "Vervangen",
    "worldFact": "Feit over de wereld",
    "characterBelief": "Overtuiging",
    "testimony": "Getuigenis",
    "authorHypothesis": "Hypothese",
    "confirm": "Bevestigen",
    "confirmExplicitApproval": "Bevestigen (expliciete goedkeuring)",
    "newFactAbout": "Nieuw feit over {{name}}",
    "predicatePlaceholder": "bezit",
    "predicate": "Predicaat",
    "valuePlaceholder": "het zwaard",
    "value": "Waarde",
    "kind": "Soort",
    "epistemicKind": "Epistemische soort",
    "kindHint": "Alleen feiten over de wereld tellen als waarheid; overtuigingen, getuigenissen en hypotheses blijven bewaard maar worden niet als canon gecontroleerd.",
    "when": "Wanneer",
    "timeKind": "Tijdtype",
    "betweenTwoMoments": "Tussen twee momenten",
    "from": "Van",
    "to": "tot",
    "startTick": "Begintick",
    "endTick": "Eindtick",
    "momentsHint": "Momenten op de tijdlijn van de wereld; het einde telt niet mee.",
    "reveal": "Onthulling",
    "maximumRevealNarrativeIndex": "Maximale onthulling (verteld volgnummer)",
    "noLimit": "Geen limiet",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Citaten van dit feit in een latere scène worden gemarkeerd.",
    "addFactProposed": "Toevoegen als voorgesteld",
    "selectAnEntityToSeeAnd": "Kies een vermelding om haar feiten te zien en toe te voegen.",
    "noEntityYet": "Nog geen vermelding. Voeg hierboven een personage, een plaats of een voorwerp toe, of doe het in de Codex.",
    "resultDetails": "Details van het resultaat",
    "conflict": "Conflict",
    "warning": "Waarschuwing",
    "whatWasCompared": "Wat is vergeleken",
    "whatToDo": "Wat te doen",
    "comparedOwnership": "Bevestigde feiten over de wereld met een tijdsbereik. Twee bezitters van hetzelfde ding mogen elkaar niet overlappen.",
    "comparedFlashback": "De tijd van elke gebeurtenis in de wereld tegenover de volgorde van haar scène in het boek.",
    "comparedReveal": "De laatste scène die je voor een feit toestond, tegenover de scènes die het citeren.",
    "comparedOrphans": "Elke notitie en elk feit tegenover de vermeldingen en Bibliotheekkaarten die bestaan.",
    "comparedAnchors": "Het citaat van elke notitie tegenover de huidige tekst van de scène.",
    "confirmOnlyOneOwnerInThe": "Laat één bezitter over voor die momenten: beperk een van de tijdsbereiken, of zet een feit terug op voorgesteld.",
    "ifTheSceneIsADeliberate": "Als de scène een bewuste flashback is, laat haar dan staan. Verplaats anders de scène of wijzig de tijd van de gebeurtenis.",
    "raiseTheMaximumRevealSceneOf": "Sta een latere scène toe voor het feit, of verplaats het citaat naar eerder.",
    "restoreTheMissingEntityFromThe": "Herstel de vermelding uit de geschiedenis van de Codex, of verwijder de notitie of het feit dat ernaar verwijst.",
    "useReAnchorManualOnThe": "Gebruik Opnieuw verankeren bij het citaat in de resultaten, of open de scène en selecteer de passage opnieuw.",
    "giveTheEventOrFactAn": "Geef het een tijd in de wereld, of laat het zonder: de controle zwijgt dan in plaats van te gokken.",
    "selectAResult": "Selecteer een resultaat",
    "detailsConstraintsAndSuggestedFixesAppear": "Wat is vergeleken en wat je kunt doen, verschijnt hier.",
    "thisAnnotationCannotBeReAnchored": "Deze notitie kan niet opnieuw worden verankerd: “{{excerpt}}” ontbreekt of komt meer dan eens voor in de scène.",
    "revisionTools": "Revisiehulpmiddelen",
    "loadingRevisionTools": "Revisiehulpmiddelen laden…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "De inhoud is gewijzigd terwijl ze werd bevestigd. Kies de inhoud en goedkeuring die je hebt bekeken.",
    "theseChangesCannotBeCombinedInto": "Deze wijzigingen kunnen niet tot een geldige Wereld worden samengevoegd. Kies de volledige versie die je wilt houden; beide kopieën blijven in het herstel.",
    "thisDevice": "Dit apparaat",
    "yourAccount": "Je account",
    "viewWorld": "Wereld bekijken",
    "previousSharedValue": "Vorige gedeelde waarde",
    "theActionCouldNotFinishYour": "De actie kon niet worden voltooid. Je lokale wijzigingen blijven bewaard.",
    "worldSync": "Synchronisatie van de wereld",
    "syncCodexPagesFactsTimelinesCollections": "Synchroniseer codexpagina’s, feiten, tijdlijnen, collecties en bijlagen tussen apparaten. Notities en schetsen synchroniseren zelfstandig, hieronder.",
    "syncWorldAutomatically": "Wereld automatisch synchroniseren",
    "n1PendingChange": "1 wijziging in afwachting",
    "pendingPendingChanges": "{{pending}} wijzigingen in afwachting",
    "syncNow": "Nu synchroniseren",
    "exportRecoveryCopies": "Herstelkopieën exporteren",
    "compareBeforeSyncing": "Vergelijken voordat je synchroniseert",
    "signInToTheLinkedAccount": "Log in op het gekoppelde account om te synchroniseren. Lokale wijzigingen blijven opgeslagen.",
    "signInToCompareYourWorld": "Log in om je Wereld te vergelijken en synchronisatie in te schakelen.",
    "chooseYourStartingWorld": "Kies je beginwereld",
    "bothCopiesHaveTheSameContent": "Beide kopieën hebben dezelfde inhoud.",
    "keepTheWorldOnThisDevice": "Houd de Wereld op dit apparaat, of gebruik de kopie in je account. De vorige lokale Wereld en bijlagen blijven in het herstel bewaard.",
    "keepThisDeviceSync": "Dit apparaat houden en synchroniseren",
    "useAccountCopySync": "Accountkopie gebruiken en synchroniseren",
    "cancel": "Annuleren",
    "reviewConcurrentChanges": "Gelijktijdige wijzigingen nakijken",
    "chooseEachValueToKeepOther": "Kies voor elke waarde wat je houdt. Andere wijzigingen worden automatisch samengevoegd. Beide versies blijven herstelbaar.",
    "applyReviewedChoices": "Nagekeken keuzes toepassen",
    "syncingWorldAndAttachments": "Wereld en bijlagen synchroniseren…",
    "codexPages": "Codexpagina’s",
    "onThisDevice": "Op dit apparaat",
    "waitingToSync": "Wacht op synchronisatie",
    "syncing": "Synchroniseren…",
    "upToDate": "Up-to-date",
    "reviewNeeded": "Nakijken nodig",
    "emptyText": "(lege tekst)",
    "emptyList": "(lege lijst)",
    "worldStructure": "Structuur van de wereld",
    "labelFacts": "Feiten",
    "labelEvents": "Gebeurtenissen",
    "labelKnowledge": "Kennis",
    "labelAnnotations": "Annotaties",
    "labelRelationships": "Relaties",
    "labelAttachments": "Bijlagen",
    "labelCollections": "Collecties",
    "labelFolders": "Mappen",
    "paused": "Gepauzeerd",
    "addedCount_one": "{{count}} toegevoegd",
    "addedCount_other": "{{count}} toegevoegd",
    "removedCount_one": "{{count}} verwijderd",
    "removedCount_other": "{{count}} verwijderd",
    "changedCount_one": "{{count}} gewijzigd",
    "changedCount_other": "{{count}} gewijzigd",
    "removedValue": "Verwijderd",
    "emptyValue": "Leeg"
  },
  "worldReviewTools": {
    "deletedEntry": "Verwijderde vermelding",
    "timeUnknown": "Tijd onbekend",
    "storyTimeInterval": "Tijdvak in verhaaltijd",
    "relativeToEventPreserved": "Ten opzichte van gebeurtenis (behouden)",
    "from": "Van",
    "until": "Tot",
    "characterKnowledge": "Kennis van personages",
    "couldNotCheckTheSavedManuscriptRetry": "Het opgeslagen manuscript kon niet worden gecontroleerd. Probeer het opnieuw.",
    "revisionTools": "Revisiehulpmiddelen",
    "changeImpact": "Impact van wijzigingen",
    "whatPointsToThisRecord": "Wat verwijst naar dit record?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Alleen expliciete koppelingen, ook indirecte. Een record wijzigen herschrijft de afhankelijke records niet.",
    "impactRecord": "Impact-record",
    "chooseARecord": "Kies een record",
    "linkedRecordsWorldRevision": "gekoppelde records · wereldrevisie",
    "directLink": "Directe koppeling",
    "missingSourceScene": "Ontbrekende bronscène",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Geen expliciete recordkoppelingen naar deze vermelding. Niet-gekoppelde tekst valt buiten deze controle.",
    "whenDidTheyLearnIt": "Wanneer leerden ze het?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Leg verwerving en gebruik vast op dezelfde as van verhaaltijd. Gokken en overtuigingen blijven gescheiden; de volgorde van hoofdstukken geldt nooit als verhaaltijd.",
    "recordKnowledge": "Kennis vastleggen",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Opslaan mislukt. Controleer de tijdvakken, of annuleer en open opnieuw als de Wereld is gewijzigd.",
    "character": "Personage",
    "knowledgeCharacter": "Personage met de kennis",
    "chooseACharacter": "Kies een personage",
    "fact": "Feit",
    "knowledgeFact": "Feit van de kennis",
    "chooseAConfirmedWorldFact": "Kies een bevestigd feit over de wereld",
    "acquired": "Verworven",
    "acquisitionSource": "Bron van verwerving",
    "noSourceAttached": "Geen bron gekoppeld",
    "use": "Gebruik",
    "scene": "Scène",
    "chooseAScene": "Kies een scène",
    "knownInformation": "Bekende informatie",
    "belief": "Overtuiging",
    "guess": "Gok",
    "passageSource": "Bron van de passage",
    "noPassageAttached": "Geen passage gekoppeld",
    "removeUse": "Gebruik verwijderen",
    "addUse": "Gebruik toevoegen",
    "confirmAndSave": "Bevestigen en opslaan",
    "cancel": "Annuleren",
    "missingFact": "Ontbrekend feit",
    "atUnknownRelativeTime": "op onbekende/relatieve tijd",
    "edit": "Bewerken",
    "couldNotRemoveTheRecordRefreshAndRetry": "Het record kon niet worden verwijderd. Vernieuw en probeer het opnieuw.",
    "checkSavedKnowledge": "Opgeslagen kennis controleren",
    "theWorldChangedSinceThisResultRunTheCheck": "De Wereld is gewijzigd sinds dit resultaat. Voer de controle opnieuw uit.",
    "recordedUseIsEarlierThanAcquisition": "Vastgelegd gebruik is eerder dan verwerving",
    "recordedTimesAreInOrder": "Vastgelegde tijden staan in de juiste volgorde",
    "beliefOrGuessNotAKnowledgeConflict": "Overtuiging of gok — geen kennisconflict",
    "notEnoughInformationToCompare": "Te weinig informatie om te vergelijken",
    "attachedPassagesMatchTheSavedText": "Gekoppelde passages komen overeen met de opgeslagen tekst",
    "aSourceIsMissingStaleOrBelongsToAnother": "Een bron ontbreekt, is verouderd of hoort bij een andere scène",
    "authorRecordedTimesPassagesAreNotVerified": "Door de auteur vastgelegde tijden; passages zijn niet geverifieerd",
    "openScene": "Scène openen",
    "noConfirmedKnowledgeUsesToCompare": "Geen bevestigd kennisgebruik om te vergelijken.",
    "openNamedScene": "{{title}} openen",
    "recordSummary": "Gebruik: {{count}} · {{lifecycle}} · Verworven {{time}}",
    "checkSummary": "Gecontroleerd om {{time}} · vastgelegd gebruik: {{count}}. Vernieuw na het bewerken van de tekst.",
    "resultsLimitedTo500Records": "Resultaten beperkt tot 500 records",
    "linksAway": "{{depth}} koppelingen verderop",
    "useNKind": "Gebruik {{n}}: soort",
    "useN": "Gebruik {{n}}",
    "useNSource": "Gebruik {{n}}: bron",
    "checking": "Controleren…"
  },
  "worldSection": {
    "overview": "Overzicht",
    "vault": "Archief",
    "timeline": "Tijdlijn",
    "connections": "Verbindingen",
    "references": "Verwijzingen",
    "checks": "Controles",
    "analysis": "Analyse",
    "characters": "Personages",
    "locations": "Locaties",
    "factions": "Facties",
    "objects": "Voorwerpen",
    "concepts": "Concepten",
    "worldViews": "Wereldweergaven",
    "world": "Wereld",
    "browseByType": "Bladeren op type",
    "filterByType": "Filteren op type",
    "all": "Alle",
    "newEntry": "Nieuwe vermelding",
    "cercaNelCodex": "De Codex doorzoeken",
    "searchEntries": "Vermeldingen zoeken…",
    "entry": "vermelding",
    "entries": "vermeldingen",
    "alsoAliases": "Ook: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Nog geen vermeldingen. Maak het eerste personage, de eerste plaats of factie.",
    "noEntryMatches": "Geen vermelding komt overeen.",
    "editName": "{{name}} bewerken",
    "edit": "Bewerken",
    "archive": "Archiveren",
    "confirmArchive": "Archiveren bevestigen",
    "notesAndSketches": "Notities en schetsen",
    "alsoKnownAs": "Ook bekend als",
    "addADescriptionOneLineThat": "Voeg een beschrijving toe — één regel die zegt wat dit is.",
    "none": "Geen",
    "yes": "Ja",
    "no": "Nee",
    "removedEntry": "Verwijderde vermelding",
    "unavailableEntry": "Niet-beschikbare vermelding",
    "noNotesYetEditTheEntry": "Nog geen notities. Bewerk de vermelding om haar te beschrijven.",
    "linkedScenes": "Gekoppelde scènes",
    "showTheEntriesOfABook": "De vermeldingen van een boek tonen",
    "allBooks": "Alle boeken",
    "bookLine": "Boek {{number}} · {{title}}",
    "inNoBookYet": "Nog in geen enkel boek",
    "scenesThatMentionThisEntryBy": "Scènes die deze vermelding bij naam of alias noemen, verschijnen hier.",
    "facts": "Feiten",
    "noFactRecordedFactsAreAdded": "Geen feit vastgelegd. Feiten worden toegevoegd en goedgekeurd in Controles.",
    "relations": "Relaties",
    "noRelationYet": "Nog geen relatie.",
    "proposed": " · voorgesteld",
    "viewAll": "Alles bekijken",
    "attachments": "Bijlagen",
    "attachAnImageToUseIt": "Voeg een afbeelding toe om haar als portret te gebruiken.",
    "kib": "KiB",
    "open": "Openen",
    "remove": "Verwijderen",
    "addAttachment": "Bijlage toevoegen",
    "stateAtStoryTime": "Stand in verhaaltijd",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "feiten zonder volledig tijdvak.",
    "selectAnEntry": "Selecteer een vermelding",
    "charactersPlacesFactionsAndObjectsLive": "Personages, plaatsen, facties en voorwerpen leven hier, met hun feiten, relaties en bijlagen.",
    "recentChanges": "Recente wijzigingen",
    "undoChange": "Wijziging ongedaan maken",
    "worldTimeline": "Tijdlijn van de wereld",
    "eventsPeopleAndPlacesInA": "Gebeurtenissen, mensen en plaatsen in een groter geheel.",
    "noEventYet": "Nog geen gebeurtenis",
    "addTheFirstEventWithA": "Voeg de eerste gebeurtenis toe met een verhaaltijd, of laat de tijd onbekend tot je die weet.",
    "tick2": "tick",
    "plotEvent": "Plotgebeurtenis",
    "worldEvent": "Gebeurtenis in de wereld",
    "openScene": "Scène openen",
    "unknownTime": "Onbekende tijd",
    "unknown": "onbekend",
    "seeHowYourWorldSPeople": "Zie hoe de mensen, plaatsen en ideeën van je wereld met elkaar verbonden zijn.",
    "connectionsView": "Verbindingenweergave",
    "graph": "Grafiek",
    "list": "Lijst",
    "nothingToConnectYet": "Nog niets om te verbinden",
    "createEntriesInTheCodexAnd": "Maak vermeldingen in de Codex en leg hun relaties vast in de lijstweergave.",
    "selectedEntry": "Geselecteerde vermelding",
    "relationSummary": "Samenvatting van de relaties",
    "noSceneMentionsThisEntryYet": "Nog geen scène noemt deze vermelding.",
    "openInCodex": "Openen in Codex",
    "selectANodeToSeeIts": "Selecteer een knooppunt om zijn relaties en scènes te zien.",
    "annotationsAnchoredInTheManuscriptAnd": "Annotaties verankerd in het manuscript en de bestanden die je voor je wereld bewaart.",
    "addFile": "Bestand toevoegen",
    "annotations": "Annotaties",
    "selectTextInTheManuscriptAnd": "Selecteer tekst in het manuscript en gebruik “Annoteren” om een stijlmiddel, een entiteit of een notitie te verankeren.",
    "scene": "Scène",
    "device": "Stijlmiddel",
    "entity": "Entiteit",
    "note": "Notitie",
    "imagesPdfsNotesAndAudioYou": "Afbeeldingen, pdf’s, notities en audio die je aan de wereld of aan een vermelding koppelt.",
    "linked": "Gekoppeld",
    "orphan": "Wees",
    "openFile": "Bestand openen",
    "referenceDetails": "Details van de verwijzing",
    "textAnnotation": "Tekstannotatie",
    "kind": "Soort",
    "anchor": "Anker",
    "concept": "Concept",
    "created": "Aangemaakt",
    "anchorStatesValidStaleOrphanedAnd": "De ankerstatussen (geldig, verouderd, wees) en het opnieuw verankeren worden berekend in Controles.",
    "attachment": "Bijlage",
    "type": "Type",
    "size": "Grootte",
    "linkedTo": "Gekoppeld aan",
    "added": "Toegevoegd",
    "confirmRemove": "Verwijderen bevestigen",
    "selectAnAnnotationOrAFile": "Selecteer een annotatie of een bestand.",
    "exploreTheShapeOfYourStory": "Verken de vorm van je verhaal: lengte, aanwezigheid en dichtheid over de scènes heen.",
    "sceneLength": "Scènelengte",
    "wordsPerScene": "Woorden per scène",
    "noScenesYet": "Nog geen scènes.",
    "titleFmtWords": "{{title}}: {{fmt}} woorden",
    "entityDensity": "Entiteitsdichtheid",
    "codexMentionsPerScene": "Codexvermeldingen per scène",
    "titleMentionsMentions": "{{title}}: {{mentions}} vermeldingen",
    "characterAppearanceMap": "Aanwezigheidskaart van personages",
    "aDotWhereACharacterIs": "Een stip waar een personage in een scène wordt genoemd",
    "addCharactersToTheCodexAnd": "Voeg personages toe aan de Codex en noem ze in scènes.",
    "thisScene": "Deze scène",
    "words": "Woorden",
    "paragraphs": "Alinea’s",
    "sentencesEst": "Zinnen (geschat)",
    "distinctWords": "Verschillende woorden",
    "annotatedDevices": "Geannoteerde stijlmiddelen",
    "n1000Words": "/ 1.000 woorden",
    "repetitions": "Herhalingen",
    "exportHtml": "HTML exporteren",
    "exportTxt": "TXT exporteren",
    "events": "Gebeurtenissen",
    "confirmedFacts": "Bevestigde feiten",
    "recentlyChanged": "Recent gewijzigd",
    "changesToTheWorldWillBe": "Wijzigingen aan de wereld worden hier vermeld, elk met een knop om ze ongedaan te maken.",
    "undo": "Ongedaan maken",
    "startHere": "Begin hier",
    "overviewEmptyLead": "De mensen, plaatsen en gebeurtenissen van je verhaal, gekoppeld aan de scènes waarin ze voorkomen.",
    "addACharacter": "Een personage toevoegen",
    "addACharacterText": "Wie ze zijn, wat ze willen en wat in de weg staat.",
    "addAPlace": "Een plaats toevoegen",
    "addAPlaceText": "Waar scènes zich afspelen: een stad, een schip, één enkele kamer.",
    "addAnEventText": "Iets wat in het verhaal gebeurt, met of zonder datum.",
    "inThisWorld": "In deze wereld",
    "createAnEntry": "Een vermelding maken",
    "aCharacterAPlaceAFaction": "Een personage, een plaats, een factie, een voorwerp of een concept.",
    "addAnEvent": "Een gebeurtenis toevoegen",
    "withAnExactStoryTimeOr": "Met een exacte verhaaltijd of een onbekende.",
    "runTheChecks": "De controles uitvoeren",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Eigenaren, volgorde, onthullingen en relaties in de tijd, vergeleken met de tekst.",
    "loadingTheWorld": "De wereld laden…",
    "maps": "Kaarten",
    "openItsMap": "De bijbehorende kaart openen",
    "addAMap": "Een kaart toevoegen",
    "pinnedOn": "Vastgepind op",
    "typeCharacter": "Personage",
    "typeLocation": "Locatie",
    "typeObject": "Voorwerp",
    "typeFaction": "Factie",
    "typeConcept": "Concept",
    "annotationsToReAnchor_one": "{{count}} annotatie opnieuw te verankeren.",
    "annotationsToReAnchor_other": "{{count}} annotaties opnieuw te verankeren."
  }
}
